import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Drawer, Tabs, Descriptions } from 'antd';
import styled from 'styled-components';

//Components
import Wait4Me from '../../../components/Wait4Me';
import BreadCrumb from '../../../components/BreadCrumb';
import WatchAndWhitelistTable from '../../../components/ns/WatchAndWhitelistTable';
import style from './index.scss';

const { TabPane } = Tabs;

const LoadingWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const WhiteList = (props) => {
  const { apiActions, settings, whiteListData } = props;

  const [visible, setVisible] = useState(false);
  const [drawerRecord, setDrawerRecord] = useState({});
  const [activeTab, setActiveTab] = useState('1');

  useEffect(() => {
    apiActions?.getNSGlobalSettingsPageInfo({ pageId: 'NS_IAD_WHITELIST' });
    apiActions?.getNSRIWhiteListInitiate();
  }, []);

  const showDrawer = (record) => {
    setDrawerRecord(record);
    setVisible(true);
  };
  const onClose = () => {
    setActiveTab('1');
    setVisible(false);
  };

  const onChangeTabHandler = (selectedTab) => {
    setActiveTab(selectedTab);
  };

  // To Get Global Settings Configuration
  const getGSConfig = (q) => {
    if (settings?.nsSetting?.data?.uiWidgetGroups) {
      const groups = settings.nsSetting.data.uiWidgetGroups;
      return groups
        .find((g) => g.widgetGroupId === q.widgetGroupId)
        ?.widgets.find((w) => w.widgetId === q.widgetId);
    }
    return {};
  };

  // Global Settings config
  const GS = getGSConfig({
    widgetGroupId: 'NS_IAD_LIST_WHITELIST',
    widgetId: 'NS_IAD_LIST_WHITELIST'
  });

  const percentage = (changedValue, totalValue) => {
    if (!changedValue || !totalValue) {
      return '-';
    } else {
      return `${((100 * changedValue) / totalValue).toFixed(2)}%`;
    }
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <div className={style.whitelist_wrapper}>
            <div className={style.head}>
              <BreadCrumb crumbs={[{ label: 'Whitelist' }]} />
              <div className={style.head_content}>
                <h4>Whitelist</h4>
              </div>
            </div>
            <div className={style.tableContent}>
              <h4>Whitelist</h4>
              <div className={style.table}>
                {settings?.nsSetting?.isLoading ? (
                  <LoadingWrapper>
                    <Wait4Me />
                  </LoadingWrapper>
                ) : (
                  <WatchAndWhitelistTable
                    {...props}
                    GS={GS}
                    tableData={{
                      isLoading: whiteListData.isLoading,
                      data: whiteListData.data
                    }}
                    hasRowSelection={false}
                    hasPagination={true}
                    component="whitelist"
                    showDrawer={showDrawer}
                  />
                )}
              </div>
            </div>
            <Drawer
              title={`${drawerRecord?.id} ${drawerRecord?.name}`}
              placement="right"
              width={364}
              height={866}
              closable={true}
              onClose={onClose}
              visible={visible}
              className={style.whitelist_drawer}>
              <Tabs
                activeKey={activeTab}
                className={style.tab}
                onChange={onChangeTabHandler}>
                <TabPane tab="Recent Changes" id="recentChanges" key="1">
                  <Descriptions
                    column={1}
                    size="middle"
                    bordered
                    labelStyle={{
                      background: 'none',
                      fontSize: '10px',
                      lineHeight: '12px',
                      width: '50%',
                      paddingLeft: '8px'
                    }}
                    contentStyle={{
                      fontSize: '10px',
                      lineHeight: '12px',
                      width: '50%',
                      paddingLeft: '8px'
                    }}>
                    <Descriptions.Item label="New Records">
                      {drawerRecord?.['recordsAdded']?.toLocaleString('en-US')
                        ? drawerRecord?.['recordsAdded']?.toLocaleString(
                            'en-US'
                          )
                        : '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Changed Records">
                      {drawerRecord?.['recordsChanged']?.toLocaleString('en-US')
                        ? drawerRecord?.['recordsChanged']?.toLocaleString(
                            'en-US'
                          )
                        : '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Total Records">
                      {drawerRecord?.['recordCount']?.toLocaleString('en-US')
                        ? drawerRecord?.['recordCount']?.toLocaleString('en-US')
                        : '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Deleted Records">
                      {drawerRecord?.['recordsDeleted']?.toLocaleString('en-US')
                        ? drawerRecord?.['recordsDeleted']?.toLocaleString(
                            'en-US'
                          )
                        : '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Percentage(%) of Change">
                      {percentage(
                        drawerRecord?.['recordsChanged'],
                        drawerRecord?.['recordCount']
                      )}
                    </Descriptions.Item>
                  </Descriptions>
                </TabPane>
                <TabPane tab="Coverage" key="2">
                  <div id="tabCoverage">Coverage is coming soon!</div>
                </TabPane>
                <TabPane tab="Report" key="3">
                  <div id="tabReport">Report is coming soon!</div>
                </TabPane>
              </Tabs>
            </Drawer>
          </div>
        </Col>
      </Row>
    </>
  );
};

WhiteList.propTypes = {
  apiActions: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  whiteListData: PropTypes.object.isRequired
};

export default WhiteList;
